"use strict";
/**
* Принимает строку email и проверяет соответствует ли она регулярному выражению
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = void 0;
function isEmail(email) {
    return /^.+@.+\..+$/.test(email);
}
exports.isEmail = isEmail;
//# sourceMappingURL=isEmail.js.map